const C = 1e3, F = (o, n) => {
  const t = n && "plan" in n && n.plan ? n.plan?.calibrationPoints?.map?.points : void 0;
  if (t && t.length >= 2) {
    const s = t;
    let a, l;
    const g = s.find((i) => i.id === "floorplan_northeast"), u = s.find((i) => i.id === "floorplan_southwest");
    if (g && u)
      a = new google.maps.LatLng(g.latitude, g.longitude), l = new google.maps.LatLng(u.latitude, u.longitude);
    else {
      let i = 1 / 0, d = 1 / 0, c = -1 / 0, m = -1 / 0;
      s.forEach((f) => {
        i = Math.min(i, f.latitude), d = Math.min(d, f.longitude), c = Math.max(c, f.latitude), m = Math.max(m, f.longitude);
      }), a = new google.maps.LatLng(c, m), l = new google.maps.LatLng(i, d);
    }
    return new google.maps.LatLngBounds(l, a);
  }
  const e = 5e-4;
  return new google.maps.LatLngBounds(new google.maps.LatLng(o.lat - e, o.lng - e), new google.maps.LatLng(o.lat + e, o.lng + e));
}, w = (o, n) => ({
  rotation: n ? Math.round(n) : 0,
  skewX: 0,
  skewY: 0,
  opacity: 0.9,
  position: o,
  bounds: void 0,
  visible: !0
}), S = (o, n, r, t) => {
  if (!r || !google.maps.geometry || !google.maps.geometry.spherical)
    return console.error("Bounds or Google Maps Geometry library not available."), null;
  const e = r.getNorthEast(), s = r.getSouthWest(), a = r.getCenter();
  if (!e || !s || !a)
    return console.error("Could not get bounds corners or center."), null;
  const l = o / 1e3, g = 1 - n / 1e3, u = Math.max(0, Math.min(1, l)), i = Math.max(0, Math.min(1, g)), d = s.lng() + (e.lng() - s.lng()) * u, c = s.lat() + (e.lat() - s.lat()) * i, m = new google.maps.LatLng(c, d), f = google.maps.geometry.spherical.computeHeading(a, m), h = google.maps.geometry.spherical.computeDistanceBetween(a, m), L = (f + t) % 360, p = google.maps.geometry.spherical.computeOffset(a, h, L);
  return {
    lat: p.lat(),
    lng: p.lng()
  };
}, M = (o, n, r) => {
  if (!r.bounds || !google.maps.geometry || !google.maps.geometry.spherical)
    return console.error("Bounds or Google Maps Geometry library not available for LatLng to Offset conversion."), null;
  const t = r.bounds, e = r.rotation, s = t.getNorthEast(), a = t.getSouthWest(), l = t.getCenter();
  if (!s || !a || !l)
    return console.error("Could not get bounds corners or center for LatLng to Offset conversion."), null;
  const g = new google.maps.LatLng(o, n), u = google.maps.geometry.spherical.computeHeading(l, g), i = google.maps.geometry.spherical.computeDistanceBetween(l, g), d = (u - e + 360) % 360, c = google.maps.geometry.spherical.computeOffset(l, i, d), m = c.lat(), f = c.lng(), h = s.lat() - a.lat(), L = s.lng() - a.lng();
  if (Math.abs(L) < 1e-9 || Math.abs(h) < 1e-9)
    return {
      xOffset: 500,
      yOffset: 500
    };
  let p = (f - a.lng()) / L, b = (m - a.lat()) / h;
  p = Math.max(0, Math.min(1, p)), b = Math.max(0, Math.min(1, b));
  const y = p * 1e3, O = (1 - b) * 1e3;
  return {
    xOffset: Math.round(y),
    yOffset: Math.round(O)
  };
}, E = (o) => {
  const n = o.plan?.calibrationPoints?.map?.center;
  if (n)
    return {
      lat: n.latitude,
      lng: n.longitude
    };
  const r = o.plan?.calibrationPoints?.map?.points;
  if (r && r.length >= 2 && typeof google < "u" && google.maps?.LatLngBounds)
    try {
      const e = F({
        lat: 0,
        lng: 0
      }, o)?.getCenter();
      if (e)
        return {
          lat: e.lat(),
          lng: e.lng()
        };
    } catch (t) {
      console.error("Error calculating center from bounds in getPositionFromConfig:", t);
    }
  return console.warn(`Could not determine initial position for overlay ID: ${o.id}. Missing center or sufficient points in config.`), null;
}, T = (o) => {
  const n = {};
  return o && (typeof google < "u" && google.maps?.geometry?.spherical || console.warn("generateInitialTransforms: Google Maps API (geometry library) not ready. Bounds calculation might be affected."), o.forEach((t) => {
    if (!t?.id) {
      console.warn("generateInitialTransforms: Skipping overlay config due to missing ID.", t);
      return;
    }
    const e = E(t), s = t.plan?.calibrationPoints?.map?.heading ?? 0;
    if (!e) {
      console.warn(`generateInitialTransforms: Skipping transform for overlay ${t.id} due to missing position.`);
      return;
    }
    const a = w(e, s);
    a.bounds = F(e, t), n[t.id] = a;
  })), n;
}, P = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  OFFSET_SCALE: 1e3,
  convertFloorPlanOffsetsToLatLng: S,
  convertLatLngToFloorPlanOffsets: M,
  createInitialBounds: F,
  createStableTransform: w,
  generateInitialTransforms: T
}, Symbol.toStringTag, { value: "Module" }));
export {
  C as O,
  F as a,
  S as b,
  w as c,
  M as d,
  T as g,
  P as m
};
